// extracted by mini-css-extract-plugin
export default {"container":"brands_container__Yg7sS","singleItem":"brands_singleItem__GmMBe"};